import createResource from './createResource';
import { AppointmentType } from './types';

const appointmentTypesResource = createResource<AppointmentType>({
  key: 'appointmentTypes',
  url: '/appointmentTypes',
  hasFetchBulkSupport: true,
});

export default appointmentTypesResource;
